export const styles = {
  badge: {
    '& .MuiBadge-badge': {
      backgroundColor: '#FF4D4F',
    },
  },
  popover: {
    '& .MuiPaper-root': {
      //marginTop: '17px',
      boxShadow: '0 2px 2px 3px rgba(0,0,0,0.05)',
      borderRadius: '4px',
      minWidth: '512px',
      maxWidth: '512px',
      //minHeight: '217px',
    },
  },
  toggleButtonsGroup: {
    backgroundColor: '#eeeeee',
    padding: '8px',
    borderRadius: '0px',
    width: '100%',
    '& .MuiToggleButton-root': {
      width: '100%',
      height: '36px',
      textTransform: 'none',
      border: 0,
      borderRadius: '4px !important',
      '&.Mui-selected, &.Mui-selected:hover': {
        backgroundColor: '#009FDA',
        color: '#ffffff',
      },
    },
  },
  content: {
    padding: '12px',
  },
}
